import { useExpiredSubscriptionModalStore } from '@/v2/domains/Subscriptions/stores/useExpiredSubscriptionModal.store';

export default function onPaymentRequiredError() {
  const setModalClosed =
    useExpiredSubscriptionModalStore.getState().setModalClosed;
  setModalClosed(false);
}
